
import { SignInParams, SignUpParams } from './auth.types';
import { contextFactory } from '../../helpers';

export type AuthUser = {
  email: string;
  username: string;
  vault_id: string | null;
  xrp_address: string | null;
};

export type AuthSession = {
  apiKey: string;
};

export type AuthContextApi = {
  user: AuthUser | null;
  session: AuthSession | null;
  loading: boolean;
  signInWithPassword: (
    params: SignInParams
  ) => Promise<{ error: string | null }>;
  signUpWithPassword: (
    params: SignUpParams
  ) => Promise<{ error: string | null }>;
  signOut: () => Promise<void>;
};

const [AuthContext, useAuth] = contextFactory<AuthContextApi>({
  hook: 'useAuthContext',
  provider: 'AuthProvider',
});

export { useAuth, AuthContext };
